export default "__VITE_ASSET__DaqmAxjL__"